module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.prefixUploadClass + '-list']
  }, _vm._l((_vm.files), function(file, fileIndex) {
    return _c('div', {
      key: fileIndex,
      class: _vm.$_fileClasses(file),
      on: {
        "click": function($event) {
          return _vm.$_onUploadListClick(file)
        }
      }
    }, [_c('div', {
      staticClass: "upload-list__info",
      on: {
        "click": function($event) {
          return _vm.$_onUploadListPreviewClick(file)
        }
      }
    }, [
      [_c('t-icon', {
        attrs: {
          "type": _vm.$_format(file)
        }
      }), _vm._v(" "), _c('a', {
        staticClass: "upload-list__name",
        attrs: {
          "href": file.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(file.name))])]
    ], 2), _vm._v(" "), _c('t-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (file.status === 'finished'),
        expression: "file.status === 'finished'"
      }],
      attrs: {
        "title": "Remove file",
        "type": "close"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$_onRemoveIconClick(file)
        }
      }
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('t-progress', {
      attrs: {
        "stroke-width": 2,
        "percent": _vm.parsePercentage(file.percentage),
        "status": file.status === 'finished' && file.showProgress ? 'success' : 'normal'
      }
    })], 1)], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ae9419e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload/upload-list.vue
// module id = 349
// module chunks = 0